module.exports = "/_next/static/images/a72332ad33d4372f78f82082c8f16f50-gift-illustration@0.5x.png";